<div class="cat-count-analyse-container px-2">
    <div class="row align-items-center">
        <div class="col-6">{{'tp-analysis-type' | translate: '{defaultText: \'Analysis Type\'}'}}</div>
        <div class="col-6">
            <tp-dropdown
                label="{{'tp-analysis-type' | translate: '{ defaultText : \'Analysis Type\'}'}}"
                [formControl]="analysisType" [options]="catTools" (valueChanged)="getSelectedCatTool($event)">
            </tp-dropdown>
        </div>
    </div>
    <!-- Robert pull mode: the analysis is read from Robert, nothing is uploaded. -->
    <div class="row mt-3" *ngIf="isRobertSelected">
        <div class="col-12 text-muted">
            {{'tp-robert-analysis-pull-hint' | translate: '{ defaultText : "The analysis will be pulled from Robert for this job\'s source file. Click Analyse to review it, then Update to apply the word counts."}'}}
        </div>
    </div>
    <div class="row" *ngIf="!isRobertSelected">
        <div class="col-12">
            <div>
                <tp-drag-and-drop-file [(files)]="files" [autoUpload]="autoUpload" [multiple]="false" (selectedFiles)="getSelectedFiles($event)"></tp-drag-and-drop-file>
            </div>
            <div class="py-2">
                <tp-file-list [(files)]="files"></tp-file-list>
            </div>
        </div>
    </div>
    <div class="row mt-2" *ngIf="!isRobertSelected">
        <div class="col-12 text-right">
            <a href="javascript:void(0)" class="ai-escape-link" (click)="openAi.emit()">
                {{'tp-cat-cant-find-schema' | translate: '{ defaultText : "Can\'t find your schema?"}'}}
            </a>
        </div>
    </div>
</div>